import { setIsNewUser, setUser } from "../auth/user.reducer";
import {
  getProfileCompletionState,
  isProfileIncomplete,
} from "../auth/profileCompletion";
import {
  clearParentPostAuthRedirect,
  persistParentSessionMode,
} from "./parentFlow";
import {
  setDatadogUserContext,
  logParentPostLoginRoutingDecision,
} from "../../utils/datadogLogger";

export const finalizeParentLogin = ({
  dispatch,
  navigate,
  profileData,
  redirectPath,
}) => {
  persistParentSessionMode();
  dispatch(setUser({ user: profileData, token: profileData.jwtoken }));
  setDatadogUserContext(profileData);

  if (isProfileIncomplete(profileData)) {
    logParentPostLoginRoutingDecision(
      profileData.id || profileData.user_id,
      profileData.email,
      "/afterlogin",
      "incomplete_profile",
      redirectPath || null
    );

    const completionState = getProfileCompletionState(profileData);
    dispatch(setIsNewUser(true));
    navigate("/afterlogin", {
      replace: true,
      state: {
        loginData: profileData,
        showNameTab: completionState.isNameMissing,
        showDobTab: completionState.isDobMissing,
        showAvatarTab: completionState.isAvatarMissing,
        redirectAfterComplete: redirectPath,
      },
    });
    return;
  }

  logParentPostLoginRoutingDecision(
    profileData.id || profileData.user_id,
    profileData.email,
    redirectPath,
    "complete_profile",
    redirectPath || null
  );

  clearParentPostAuthRedirect();
  navigate(redirectPath, { replace: true });
};
